/** @jsx jsx */
import React, { memo, useCallback, useEffect, useState } from 'react';
import { css, jsx } from '@compiled/react';
import { Checkbox } from '@atlaskit/checkbox';
import { useIntl } from '@atlassian/jira-intl';
import { useArchiveIssueActions } from '../../../../controllers/main.tsx';
import {
	useArchiveIssueStates,
	getNumberOfSelectedIssuesForPage,
	getCurrentPage,
	getNumberOfIssuesForCurrentPage,
} from '../../../../controllers/selectors.tsx';
import messages from '../messages.tsx';

export const SelectCell = memo(() => {
	const [isChecked, setIsChecked] = useState(false);
	const [isIndeterminate, setIsIndeterminate] = useState(false);
	const state = useArchiveIssueStates();
	const pageNumber = getCurrentPage({ state });
	const numberOfIssuesInPage = getNumberOfIssuesForCurrentPage({ state });

	useEffect(() => {
		const numberOfSelectedIssues = getNumberOfSelectedIssuesForPage({ state, pageNumber });
		setIsIndeterminate(numberOfSelectedIssues > 0 && numberOfSelectedIssues < numberOfIssuesInPage);

		setIsChecked(numberOfSelectedIssues > 0);
	}, [numberOfIssuesInPage, pageNumber, state]);

	const { selectAllIssuesInCurrentPage, clearSelectionsInCurrentPage } = useArchiveIssueActions();

	const onChange = useCallback(() => {
		if (!isChecked) {
			selectAllIssuesInCurrentPage();
			setIsChecked(true);
		} else {
			clearSelectionsInCurrentPage();
			setIsChecked(false);
		}
	}, [clearSelectionsInCurrentPage, isChecked, selectAllIssuesInCurrentPage]);

	const { formatMessage } = useIntl();
	return (
		<div css={selectCellStyles} data-testId="archives-checkbox">
			<Checkbox
				isChecked={isChecked}
				onChange={onChange}
				isIndeterminate={isIndeterminate}
				value="Archives table checkbox"
				name="archives-table-checkbox"
				aria-label={formatMessage(messages.selectAllCheckboxLabelText)}
			/>
		</div>
	);
});

const selectCellStyles = css({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
});
